export default "__VITE_ASSET__5d55eae1__"